/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Injectable } from '@angular/core';

import { Selector, StateContext, Action, State } from '@ngxs/store';
import {
  CompaniesApiService,
  Company,
  CompanyUser,
  CompanyUsersApiService,
  CorporateProfile,
  Profile,
  User,
} from 'rest-client';

import {
  SetUserAction,
  RemoveAuthAction,
  RemoveUserMessageAction,
  SetUserMessageAction,
  SetAgencyAction,
} from './auth.actions';
import {
  AuthStateModel,
  BookingMessage,
  CompanyStateModel,
  UserStateModel,
} from './auth.model';

const INITIAL_STATE: AuthStateModel = {
  user: null,
  agency: null,
  company: null,
  showMessage: null,
};

@State<AuthStateModel>({
  name: 'auth',
  defaults: INITIAL_STATE,
})
@Injectable()
export class AuthState {
  constructor(
    private companiesApiService: CompaniesApiService,
    private companyUsersApiService: CompanyUsersApiService
  ) {}

  @Selector()
  static userData(state: AuthStateModel): UserStateModel {
    return state.user;
  }

  @Selector()
  static authData(state: AuthStateModel): AuthStateModel {
    return state;
  }

  @Selector()
  static companyData(state: AuthStateModel): CompanyStateModel {
    return state.company;
  }

  @Selector()
  static userMessage(state: AuthStateModel): BookingMessage {
    return state.showMessage;
  }

  @Action(SetUserAction)
  setUserAction(
    ctx: StateContext<AuthStateModel>,
    action: SetUserAction
  ): void {
    ctx.patchState({ user: action.user });

    const profile = this.checkIsBusinessProfile(
      action.user
    ) as CorporateProfile;

    this.setBusinessMode(profile, ctx);
  }

  private async setBusinessMode(
    profile: CorporateProfile,
    ctx: StateContext<AuthStateModel>
  ): Promise<void> {
    if (profile) {
      const company = {} as CompanyStateModel;
      const _company = await this.getCompany(profile.companyId);
      if(profile.role === 'administrator') {
        const users = await this.getCompanyUsers(_company);
        company.users = users;
      }
      company.record = profile.enableBookingRecords;
      company.blockPremium = this.checkBlockPremium(profile, _company);
      company.blockWash = _company.blockWashes;
      company.companyName = _company?.name;
      company.profileId = profile.id;
      company.id = profile.companyId;
      ctx.patchState({ company: company });
    } else {
      ctx.patchState({ company: null });
    }
  }

  private checkBlockPremium(
    profile: CorporateProfile,
    company: Company
  ): boolean {
    if (company.blockPremium) return true;
    else if (
      company.block_premium_for_some_users &&
      profile.block_premium_for_this_profile
    )
      return true;
    else return false;
  }

  private checkIsBusinessProfile(user: User): Profile {
    if (!user.defaultInvoiceProfileId) return null;
    else {
      return user?.profiles?.filter((profile: Profile) => {
        return (
          profile.hasOwnProperty('companyId') &&
          +profile.id === +user.defaultInvoiceProfileId
        );
      })[0];
    }
  }

  private async getCompany(profileId: number): Promise<Company> {
    try {
      const company = await this.companiesApiService.getCompany(profileId);
      return company;
    } catch (e) {
      return null;
    }
  }

  private async getCompanyUsers(company: Company): Promise<CompanyUser[]> {
    try {
      const usersList = await this.companyUsersApiService.listCompanyUsers(
        company
      );
      return usersList.users;
    } catch (e) {
      return null;
    }
  }

  @Action(SetAgencyAction)
  setAgencyAction(
    ctx: StateContext<AuthStateModel>,
    action: SetAgencyAction
  ): void {
    ctx.patchState({ agency: action.agency });
  }

  @Action(RemoveAuthAction)
  removeAuthAction(ctx: StateContext<AuthStateModel>): void {
    ctx.setState(INITIAL_STATE);
  }

  @Action(SetUserMessageAction)
  setUserMessageAction(
    ctx: StateContext<AuthStateModel>,
    action: SetUserMessageAction
  ): void {
    ctx.patchState({
      showMessage: action.message,
    });
  }

  @Action(RemoveUserMessageAction)
  removeUserMessageAction(ctx: StateContext<AuthStateModel>): void {
    ctx.patchState({
      showMessage: { message: '', errorMessage: false },
    });
  }
}
